import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form as FinalForm, Field } from 'react-final-form';

import {
    Button,
    Modal,
    Spinner,
} from 'components';

import FormInputField from 'components/FormInputField/FormInputField';

import {
    actions,
} from 'coupon-common/src/modules/admin/emailManager';

import styles from './SendTestEmailModal.module.scss';

const SendTestEmailModal = ({
    dispatch,
    isOpen,
    onRequestClose,
    subject,
    body,
}) => {
    const [sending, setSending] =
        useState(false);

    const [initialValues, setInitialValues] =
        useState({
            email: '',
            subject: '',
            body: '',
        });

    useEffect(() => {
        if (isOpen) {
            setInitialValues({
                email: '',
                subject: subject || '',
                body: body || '',
            });
        }
    }, [isOpen, subject, body]);

    const handleClose = () => {
        if (sending) {
            return;
        }

        onRequestClose();
    };

    const handleSend = values => {
        if (
            !values.email ||
            !values.subject ||
            !values.body
        ) {
            return;
        }

        const payload = {
            email: values.email,
            subject: values.subject,
            body: values.body,
        };

        setSending(true);

        dispatch(
            actions.sendTestEmail(
                payload,
                result => {
                    setSending(false);

                    if (result?.success) {
                        alert(
                            'Test email sent successfully'
                        );

                        handleClose();
                    } else {
                        console.error(
                            'Failed to send test email:',
                            result?.error
                        );

                        alert(
                            'Failed to send test email'
                        );
                    }
                }
            )
        );
    };

    return (
        <Modal
            title="Send Test Email"
            isOpen={isOpen}
            onRequestClose={handleClose}
        >
            <div className={styles.container}>
                <FinalForm
                    key={`${isOpen}-${subject}-${body}`}
                    initialValues={initialValues}
                    onSubmit={handleSend}
                    render={({
                        handleSubmit,
                        values,
                    }) => (
                        <form
                            onSubmit={handleSubmit}
                        >
                            <FormInputField
                                name="email"
                                label="Email Address"
                                placeholder="Enter email address"
                                type="email"
                                required
                            />

                            <FormInputField
                                name="subject"
                                label="Subject"
                                placeholder="Enter email subject"
                                required
                            />

                            <div
                                className={
                                    styles.formGroup
                                }
                            >
                                <label htmlFor="test-email-body">
                                    Body
                                </label>

                                <Field name="body" required>
                                    {({ input }) => (
                                        <textarea
                                            {...input}
                                            id="test-email-body"
                                            rows={14}
                                            className="form-control"
                                            placeholder="Enter email HTML"
                                            disabled={
                                                sending
                                            }
                                        />
                                    )}
                                </Field>
                            </div>

                            <div
                                className={
                                    styles.actions
                                }
                            >
                                <Button
                                    outline
                                    type="button"
                                    onClick={
                                        handleClose
                                    }
                                    disabled={sending}
                                >
                                    Cancel
                                </Button>

                                <Button
                                    type="submit"
                                    disabled={
                                        sending ||
                                        !values.email ||
                                        !values.subject ||
                                        !values.body
                                    }
                                >
                                    {sending ? (
                                        <Spinner show />
                                    ) : (
                                        'Send Test Email'
                                    )}
                                </Button>
                            </div>
                        </form>
                    )}
                />
            </div>
        </Modal>
    );
};

SendTestEmailModal.propTypes = {
    dispatch: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    onRequestClose: PropTypes.func.isRequired,
    subject: PropTypes.string,
    body: PropTypes.string,
};

SendTestEmailModal.defaultProps = {
    subject: '',
    body: '',
};

export default connect()(SendTestEmailModal);